export default __webpack_public_path__ + "static/media/absa.5bd95ae3.jpg";